import axios from "../api/axios";
import { useDispatch } from "react-redux";
import { logOut } from '../redux/authSlice';

const useLogout = () => {

    const dispatch = useDispatch();

    const logout = async () => {
        sessionStorage.removeItem("redirectAfterAuth");
        sessionStorage.removeItem("qualtricsSurveyId");
        dispatch(logOut());
        try {
            axios('/logout', {
                withCredentials: true
            });
        } catch (err) {
            console.error(err);
        }
    }

    return logout;
}

export default useLogout